module.exports = __webpack_public_path__ + "63a7a23ca7ced71a93e77782c2dc3410.pdf";